<div class="dialog">
  <div class="dialog-background" (click)="close()"></div>
  <div class="dialog-content">
    <h2 class="ui-headline">{{ '2fa.change_phone.title' | translate }}</h2>
    <p>{{ '2fa.change_phone.p1' | translate }}</p>
    <div class="ui-button-group reverse">
      <button (click)="close()" class="ui-button secondary">{{ '2fa.change_phone.cta2' | translate }}</button>
      <button (click)="switchOn()" class="ui-button">{{ '2fa.change_phone.cta1' | translate }}</button>
    </div>
  </div>
</div>
